import {
  VirtualizedInfiniteList,
  virtualizedListDefaultProps,
} from '$common/virtualized-list'
import { EmptySearchResult } from '$common/empty-search-result'
import { SearchListProps } from './with-search-list.types'
import { nothing } from '$helper/functions/utils'

export function SearchList<Item, SearchParams>({
  searchHook,
  searchHookParams,
  EmptyStateComponent,
  renderItem,
  ...other
}: SearchListProps<Item, SearchParams>) {
  const searchRes = searchHook(searchHookParams)

  const { loading, searchedItems, loadMore, hasMoreItemToLoad } = searchRes

  const itemCount = searchedItems ? searchedItems.length : 0

  return (
    <VirtualizedInfiniteList
      {...other}
      items={searchedItems}
      renderItem={renderItem}
      ListItem={other.ListItem}
      SkeletonItem={other.SkeletonItem}
      height={other.height}
      overscanCount={other.overscanCount}
      itemSize={other.itemSize}
      hasMoreItemToLoad={hasMoreItemToLoad ?? false}
      loadMore={loadMore ?? none}
      itemCount={itemCount}
      loading={loading}
      EmptyStateComponent={
        itemCount === 0 ? EmptySearchResult : EmptyStateComponent
      }
    />
  )
}

const none = async () => {}

SearchList.defaultProps = virtualizedListDefaultProps
